/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Member from "./Member";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";

// 등록하기 팝업
function BandEdit(props) {
  const { login, onCloseEditPop, pSeq } = props;
  const [loaded, setLoaded] = useState(false);
  const token = localStorage.getItem('token');

  // SEQ
  const [seq, setSeq] = useState(pSeq);

  // 데이타
  const [data, setData] = useState({
    band_no:'',
    serial:''
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onSubmit = async () => {
    let result = await axios.post(configState.api + "/hr/edit_band", {    
      token:token,
      ccid:login.ccid,
      level:login.level,
      seq: seq,
      band_no : data.band_no,
      serial : data.serial
    });
    if (result.data.success !== 1) {
      Swal.fire('오류',result.data.msg);
      return;
    }
    else {
      onCloseEditPop();
    }
  };

  const load_data = async () => {    
    let result = await axios.post(configState.api + "/hr/get_band_one", {
      token:token,
      ccid:login.ccid,
      level:login.level,
      seq: seq
    });    
    
    console.log(result.data.row);
    if( result.data.success !== 1) {
      Swal.fire('오류',result.data.msg);
      return;
    }    

    else {     
      setData({
        band_no : result.data.row.band_no,
        serial:result.data.row.serial,
      });      
      setLoaded(true);
    }    

  };

  // useEffect(() => {
  //   if (data.id !== undefined) {
  //     setLoaded(true);
  //     console.log(data);
  //   }
  // }, [data.id]);

  useEffect(() => {
    load_data();
  }, []);

  const on_del = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(configState.api + "/hr/del_band", {     
            token:token,
            ccid:login.ccid,
            level:login.level,       
            seq: seq
          });
          if (result.data.success === 1) {
            onCloseEditPop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  return (
    <>
      {loaded === true ? (
        <Box>
          <Box
            css={css`
              padding: 20px 60px;
            `}
          >
            <h3>밴드수정</h3>
            
            <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="band_no"
              label="밴드번호"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onHandleData}
              autoComplete="off"    
              value={data.band_no}          
            ></TextField>
          </Box>     
          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="serial"
              label="시리얼번호"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onHandleData}
              autoComplete="off"     
              value={data.serial}         
            ></TextField>
          </Box>                    
  
            <Box
              css={css`
                text-align: center;
                margin-top: 30px;
              `}
            >
              <Button variant="contained" onClick={onSubmit}>
                수정완료
              </Button>
              <Button
                variant="contained"
                color="warning"
                css={css`
                  margin-left: 10px;
                `}
                onClick={onCloseEditPop}                
              >
                취소
              </Button>
              <Button
                variant="contained"
                color="error"
                css={css`
                  margin-left: 10px;
                `}
                onClick={on_del}
              >
                밴드삭제
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <>Loading</>
      )}
    </>
  );
}

export default BandEdit;
